export const LogoMark = ({ size = 36 }) => (
  <svg
    data-testid="logo-daio-mark"
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    role="img"
    aria-label="DAIO logo"
  >
    <circle cx="24" cy="24" r="22" fill="rgb(var(--brand))" />
    <path
      d="M13 31a11 11 0 0 1 22 0"
      stroke="#FDFBF7"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <circle cx="24" cy="21.5" r="4.5" fill="#FDFBF7" />
    <path d="M14 36h20" stroke="#FDFBF7" strokeWidth="3" strokeLinecap="round" />
  </svg>
);
